import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import { Card, Row, Col, Collapse, Carousel } from 'antd';

const { Panel } = Collapse;
const { Meta } = Card;

export default class MobileGimbalContent1 extends React.Component {
    callback(key) {
        console.log(key);
    }

    render() {
        const cardStyle = {
            width: 220,
            padding: 8,
            margin: "0 auto",
            background: "transparent",
            border: "none"
        }
        return (
            <div className='mobile-gimbal-content1'>
                <Carousel>
                    <div style={{height:320}}>
                        <Card
                            hoverable
                            cover={<img alt="example" src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/20220407-143540.png" />}
                            style={cardStyle}
                        >
                            <Collapse onChange={this.callback} ghost expandIconPosition={"right"}>
                                <Panel header="GS3W" key="1">
                                    <p>三轴增稳</p>
                                    <p>30 倍高清无损变焦</p>
                                    <p>星光红外融合显示</p>
                                    <p>热成像</p>
                                    <p>智能跟踪</p>
                                </Panel>
                            </Collapse>
                        </Card>
                    </div>
                    <div>
                        <Card
                            hoverable
                            cover={<img alt="example" src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/20220407-143533.png" />}
                            style={cardStyle}
                        >
                            <Collapse onChange={this.callback} ghost expandIconPosition={"right"}>
                                <Panel header="GS5T" key="1">
                                    <p>三轴增稳</p>
                                    <p>30 倍高清无损变焦</p>
                                    <p>星光红外融合显示</p>
                                    <p>热成像</p>
                                    <p>智能跟踪</p>
                                    <p>激光测距</p>
                                    <p>红外镜头x2</p>
                                </Panel>
                            </Collapse>
                        </Card>
                    </div>
                    <div>
                        <Card
                            hoverable
                            cover={<img alt="example" src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/20220407-143545.png" />}
                            style={cardStyle}
                        >
                            <Collapse onChange={this.callback} ghost expandIconPosition={"right"}>
                                <Panel header="GS4L" key="1">
                                    <p>三轴增稳</p>
                                    <p>30 倍高清无损变焦</p>
                                    <p>星光红外融合显示</p>
                                    <p>热成像</p>
                                    <p>智能跟踪</p>
                                    <p>激光测距</p>
                                </Panel>
                            </Collapse>
                        </Card>
                    </div>
                </Carousel>
            </div>
        )

    }
}
